/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CurrentUser,
  ErrorResponse,
  PatchedUserUpdateRequest,
  UserDetail,
  UserList,
  UserListParams,
  UserUpdateRequest,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 시스템의 모든 사용자 목록을 조회합니다.
 * @summary 사용자 목록 조회
 */
export const userList = (
  params?: UserListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UserList[]>(
    { url: `/api/users/`, method: "GET", params, signal },
    options,
  );
};

export const getUserListQueryKey = (params?: UserListParams) => {
  return [`/api/users/`, ...(params ? [params] : [])] as const;
};

export const getUserListQueryOptions = <
  TData = Awaited<ReturnType<typeof userList>>,
  TError = ErrorType<unknown>,
>(
  params?: UserListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userList>>> = ({
    signal,
  }) => userList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UserListQueryResult = NonNullable<
  Awaited<ReturnType<typeof userList>>
>;
export type UserListQueryError = ErrorType<unknown>;

export function useUserList<
  TData = Awaited<ReturnType<typeof userList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | UserListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userList>>,
          TError,
          Awaited<ReturnType<typeof userList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserList<
  TData = Awaited<ReturnType<typeof userList>>,
  TError = ErrorType<unknown>,
>(
  params?: UserListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userList>>,
          TError,
          Awaited<ReturnType<typeof userList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserList<
  TData = Awaited<ReturnType<typeof userList>>,
  TError = ErrorType<unknown>,
>(
  params?: UserListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 사용자 목록 조회
 */

export function useUserList<
  TData = Awaited<ReturnType<typeof userList>>,
  TError = ErrorType<unknown>,
>(
  params?: UserListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getUserListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 특정 사용자의 상세 정보를 조회합니다.
 * @summary 사용자 상세 조회
 */
export const userRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UserDetail>(
    { url: `/api/users/${id}/`, method: "GET", signal },
    options,
  );
};

export const getUserRetrieveQueryKey = (id?: string) => {
  return [`/api/users/${id}/`] as const;
};

export const getUserRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof userRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userRetrieve>>> = ({
    signal,
  }) => userRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof userRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UserRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof userRetrieve>>
>;
export type UserRetrieveQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function useUserRetrieve<
  TData = Awaited<ReturnType<typeof userRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userRetrieve>>,
          TError,
          Awaited<ReturnType<typeof userRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserRetrieve<
  TData = Awaited<ReturnType<typeof userRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userRetrieve>>,
          TError,
          Awaited<ReturnType<typeof userRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserRetrieve<
  TData = Awaited<ReturnType<typeof userRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 사용자 상세 조회
 */

export function useUserRetrieve<
  TData = Awaited<ReturnType<typeof userRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getUserRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 사용자 프로필을 전체 수정합니다.
 * @summary 사용자 정보 전체 수정
 */
export const userUpdate = (
  id: string,
  userUpdateRequest: BodyType<UserUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UserDetail>(
    {
      url: `/api/users/${id}/`,
      method: "PUT",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: userUpdateRequest,
    },
    options,
  );
};

export const getUserUpdateMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userUpdate>>,
    TError,
    { id: string; data: BodyType<UserUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userUpdate>>,
  TError,
  { id: string; data: BodyType<UserUpdateRequest> },
  TContext
> => {
  const mutationKey = ["userUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userUpdate>>,
    { id: string; data: BodyType<UserUpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return userUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof userUpdate>>
>;
export type UserUpdateMutationBody = BodyType<UserUpdateRequest>;
export type UserUpdateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 사용자 정보 전체 수정
 */
export const useUserUpdate = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userUpdate>>,
      TError,
      { id: string; data: BodyType<UserUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof userUpdate>>,
  TError,
  { id: string; data: BodyType<UserUpdateRequest> },
  TContext
> => {
  const mutationOptions = getUserUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 사용자 프로필의 일부 필드만 수정합니다.
 * @summary 사용자 정보 부분 수정
 */
export const userPartialUpdate = (
  id: string,
  patchedUserUpdateRequest: BodyType<PatchedUserUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<UserDetail>(
    {
      url: `/api/users/${id}/`,
      method: "PATCH",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: patchedUserUpdateRequest,
    },
    options,
  );
};

export const getUserPartialUpdateMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userPartialUpdate>>,
    TError,
    { id: string; data: BodyType<PatchedUserUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedUserUpdateRequest> },
  TContext
> => {
  const mutationKey = ["userPartialUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userPartialUpdate>>,
    { id: string; data: BodyType<PatchedUserUpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return userPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof userPartialUpdate>>
>;
export type UserPartialUpdateMutationBody = BodyType<PatchedUserUpdateRequest>;
export type UserPartialUpdateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 사용자 정보 부분 수정
 */
export const useUserPartialUpdate = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userPartialUpdate>>,
      TError,
      { id: string; data: BodyType<PatchedUserUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof userPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedUserUpdateRequest> },
  TContext
> => {
  const mutationOptions = getUserPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 사용자 계정을 소프트 삭제합니다.
 * @summary 사용자 삭제
 */
export const userDestroy = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/api/users/${id}/`, method: "DELETE" },
    options,
  );
};

export const getUserDestroyMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userDestroy>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["userDestroy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userDestroy>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return userDestroy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof userDestroy>>
>;

export type UserDestroyMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 사용자 삭제
 */
export const useUserDestroy = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userDestroy>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof userDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getUserDestroyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 현재 로그인한 사용자의 전체 정보를 조회합니다.
 * @summary 현재 사용자 정보 조회
 */
export const userMe = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CurrentUser>(
    { url: `/api/users/me/`, method: "GET", signal },
    options,
  );
};

export const getUserMeQueryKey = () => {
  return [`/api/users/me/`] as const;
};

export const getUserMeQueryOptions = <
  TData = Awaited<ReturnType<typeof userMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userMe>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userMe>>> = ({
    signal,
  }) => userMe(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UserMeQueryResult = NonNullable<Awaited<ReturnType<typeof userMe>>>;
export type UserMeQueryError = ErrorType<ErrorResponse>;

export function useUserMe<
  TData = Awaited<ReturnType<typeof userMe>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userMe>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userMe>>,
          TError,
          Awaited<ReturnType<typeof userMe>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserMe<
  TData = Awaited<ReturnType<typeof userMe>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userMe>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userMe>>,
          TError,
          Awaited<ReturnType<typeof userMe>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserMe<
  TData = Awaited<ReturnType<typeof userMe>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userMe>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 현재 사용자 정보 조회
 */

export function useUserMe<
  TData = Awaited<ReturnType<typeof userMe>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userMe>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getUserMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
